import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import FilterIcon from "../../../../DefaultStyles/FilterIcon";
import Flex from "../../../../DefaultStyles/Flex";
import Search from "../../../../Filters/Search";

interface PartyDetailPayInfoFilterProps {
  setFilteringValue: Dispatch<SetStateAction<{ uid: string }>>;
  list?: number;
}

export default function PartyDetailPayInfoFilter({
  setFilteringValue,
  list,
}: PartyDetailPayInfoFilterProps) {
  const [searchValue, setSearchValue] = useState<string | undefined>("");

  useEffect(() => {
    if (searchValue !== "" && searchValue) {
      setFilteringValue({
        uid: searchValue,
      });
    }
  }, [searchValue]);

  return (
    <Flex style={{ marginBottom: 12 }} gapSize={10}>
      <FilterIcon maxWidth={0} />

      <Search
        placeholder="UID 입력"
        setSearchValue={setSearchValue}
        isDisabled={list === 0 || list === undefined}
      />
    </Flex>
  );
}
